import { useDrag, useDrop } from 'react-dnd'

type MoveFn = (fromIndex: number, toIndex: number) => void

export function useVideoGridDragDrop(itemId: string, index: number, moveItem: MoveFn, isReorderingMode: boolean) {
    const [{ isDragging }, drag] = useDrag({
        type: 'VIDEO_ITEM',
        item: { id: itemId, index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        canDrag: () => isReorderingMode,
    })

    // Set up drop target with improved hover handling
    const [{ isOver }, drop] = useDrop({
        accept: 'VIDEO_ITEM',
        hover: (draggedItem: { id: string; index: number }, monitor) => {
            // Only process when actually hovering over the target
            if (!monitor.isOver({ shallow: true })) {
                return
            }
            if (!monitor.canDrop()) {
                return
            }

            if (draggedItem.index !== index) {
                moveItem(draggedItem.index, index)
                draggedItem.index = index
            }
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
    })

    // Combine drag and drop refs
    const dragDropRef = (el: HTMLDivElement) => {
        drag(el)
        drop(el)
    }

    return { isDragging, isOver, dragDropRef }
}
